import React from 'react';

const Footer = () => {
    return ( 
        
        <section id="footer" className="bg-light footer-prestadores">
            <div className="container ">
                <div className="row text-center">
                    <div className="col-12 mt-2">

                        <div className="col-12 my-1">
                            <p className="my-0 text-primary font-weight-bold">Oficina Central</p>
                        </div>
                        
                        <div className="col-12 my-1">
                        Alameda 1449, Torre 2, Atención de Público en Local 12, Santiago, Chile - Metro La Moneda
                        </div>
                        
                        <div className="col-12 my-1">
                            Horario de atención: Lunes a jueves de 8.30 a 16.00 horas.
                        </div>

                        <div className="col-12 my-1">
                            Viernes de 8.30 a 15.00 horas
                        </div>

                        <div className="col-12 my-1">
                            Fono 600 836 9000 
                        </div>

                        <div className="col-12 my-2">
                            <p className=" mb-0 text-primary font-weight-bold">Agencias Regionales</p>
                        </div>

                        <div className="col-12 my-1">
                            <p>Horario de atención: Lunes a viernes de 9:00 a 14:00 horas. </p>
                        </div>
                    </div>
                        <div className="mx-auto d-none d-lg-block">
                            <p className=" d-inline text-primary col-6 col-lg-3">Mapa del Sitio</p>
                            <p className=" d-inline text-primary col-6 col-lg-3">Descarga de visualizadores</p>
                            <p className=" d-inline text-primary col-6 col-lg-3">Reclamos IP</p>
                            {/* <p className=" d-inline text-primary col-6 col-lg-3">Mail Funcionarios</p> */}
                            <p className=" d-inline text-primary col-6 col-lg-3">Histórico Transparencia</p>
                        </div>
                </div>

        </div>
        </section>

     );
}
 
export default Footer;